export const styles = {
  headline: {
    fontSize: 18,
    fontWeight: 700,
  },
};
